export const CREATE_PROJECTS_NEW_FOLDER = 'CREATE_PROJECTS_NEW_FOLDER'
